import { Card, CardContent, Typography, Box, Stack } from '@mui/material';
import type { LabourItemGroupDetails } from '../../../api/labourItemGroupsApi';

interface GroupOverviewCardProps {
  group: LabourItemGroupDetails;
}

export function GroupOverviewCard({ group }: GroupOverviewCardProps) {
  return (
    <Card variant="outlined" data-testid="group-overview-card">
      <CardContent>
        <Stack spacing={2}>
          {/* Card Title */}
          <Typography variant="h6" component="h2">
            Group Overview
          </Typography>

          {/* Group Details */}
          <Stack spacing={1.5}>
            {/* Name */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2" color="text.secondary">
                Name
              </Typography>
              <Typography variant="body2" fontWeight={500}>
                {group.name}
              </Typography>
            </Box>

            {/* Items Count */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2" color="text.secondary">
                Items Count
              </Typography>
              <Typography variant="body2" fontWeight={500}>
                {group.labourItems?.length || 0}
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
